/*
    Map fields from view model to tournament dialog model
*/
export const tournamentDialogDisplay = (tournament) =>{
    return {
        id: tournament.tournamentId,
        business_group_logo: null,
        name: tournament.tournamentName,
        active: true,
        game_name: tournament.gameName,
        game_image: tournament.gameImage,
        game_id: tournament.gameId,
        info: tournament.tournamentDescription,
    }

}


// WEBPACK FOOTER //
// ./src/components/containers/tournament-creator/tournament-field-mapper.js